import {
  focManyToManySchemeSampleFile,
  focManyToOneSchemeSampleFile,
  focSchemeSampleFile,
  liquidationSchemeSampleFile,
  productsUploadSampleFile,
  upgradeOfferSchemeSampleFile,
} from '../constants';

export const schemeTypes = [
  'Sell-in',
  'Sell-out',
  'Price-drop',
  // 'Liquidation',
  'Upgrade-offer',
  'FOC',
  'Demo',
  'Marketing',
  'Reimbursement',
];

export const indexingSchemeTypes = ['Demo', 'Reimbursement'];

export const schemeTypeMap = {
  sellIn: 'Sell-in',
  sellOut: 'Sell-out',
  priceDrop: 'Price-drop',
  // liquidation: 'Liquidation',
  upgradeOffer: 'Upgrade-offer',
  foc: 'FOC',
  demo: 'Demo',
  marketing: 'Marketing',
  reimbursement: 'Reimbursement',
};

export const schemeSubTypes = (schemeType) => {
  let result = [];
  switch (schemeType) {
    case 'Sell-in':
      result = ['On-Invoice', 'Off-Invoice'];
      break;
    case 'Upgrade-offer':
      result = ['With-Buyback', 'Without-Buyback'];
      break;
    case schemeTypeMap.foc:
      result = [schemeTypeMap.sellIn, schemeTypeMap.sellOut];
      break;
    case schemeTypeMap.marketing:
      result = [schemeTypeMap.sellIn, schemeTypeMap.sellOut, 'Indexing'];
      break;
    default:
      break;
  }
  return result;
};

export const focTypes = ['One-One', 'One-Many', 'Many-One', 'Many-Many'];

export const focExcelSheetNamesMap = {
  applicableModel: 'Applicable Models',
  focModel: 'FOC Models',
  slabs: 'Slabs',
  incrementalQuantity: 'Incremental Qty After Last Slab',
  capping: 'Capping',
  applicableAndFocModel: 'Applicable & FOC Models',
};

export const getExampleExcelForScheme = (schemeType, focType) => {
  let result = '';
  switch (schemeType) {
    case 'Liquidation':
      result = upgradeOfferSchemeSampleFile;
      break;
    case 'Upgrade-offer':
      result = upgradeOfferSchemeSampleFile;
      break;
    case 'liquidationFile':
      result = liquidationSchemeSampleFile;
      break;
    case schemeTypeMap.foc:
      if (focType === 'Many-Many') {
        result = focManyToManySchemeSampleFile;
      } else if (focType === 'Many-One') {
        result = focManyToOneSchemeSampleFile;
      } else {
        result = focSchemeSampleFile;
      }
      break;
    default:
      result = productsUploadSampleFile;
      break;
  }

  return result;
};

export const formatToINR = (value) => {
  let num = Number(value);

  if (isNaN(num)) {
    return '0';
  }

  return new Intl.NumberFormat('en-IN', {
    currency: 'INR',
    minimumFractionDigits: 2,
  }).format(num);
};
